import React, { useState } from "react";
import VendorSearch from "../Vendor/VendorSearch";
import { useStyles } from "./Style";
import {
	Button,
	InputAdornment,
	InputLabel,
	OutlinedInput,
	MenuItem,
	Select,
	Typography,
	Divider,
	Grid,
} from "@material-ui/core";
import useAssetProvider from "../useAssetProvider";

const NewAsset = ({
	newAsset,
	setNewAsset,
	vendor,
	setVendor,
	transactionType,
	setTransactionType,
	amount,
	setAmount,
}) => {
	const classes = useStyles();
	const { locations } = useAssetProvider();
	const [selectedTranType, setSelectedTranType] = useState("");
	
	const handleTrasactionType = (type) => {
		if (type === "Trade In")
			setNewAsset({
				...newAsset,
				is_trade_in: true,
				is_collateral: false,
				is_cashout: false,
			});
		else if (type === "Collateral")
			setNewAsset({
				...newAsset,
				is_trade_in: false,
				is_collateral: true,
				is_cashout: false,
			});
		else if (type === "Cash Out")
			setNewAsset({
				...newAsset,
				is_trade_in: false,
				is_collateral: false,
				is_cashout: true,
			});
		else
			setNewAsset({
				...newAsset,
				is_trade_in: false,
				is_collateral: false,
				is_cashout: false,
			});
	};

	return (
		<>
			{transactionType && newAsset.type ? (
				<div className={classes.formControl}>
					{transactionType === "Selling" && (
						<div style={{ margin: "20px 0px", textAlign: "center" }}>
							<Typography variant="h5" align="left">
								{newAsset.type}
							</Typography>
							<Divider style={{ marginBottom: 10 }} />
							<InputLabel htmlFor="selling-price-input">Selling Price</InputLabel>
							<OutlinedInput
								style={{ width: "100%" }}
								value={newAsset.price}
								onChange={(e) =>
									setNewAsset({ ...newAsset, price: parseInt(e.target.value) })
								}
								type="number"
								id="selling-price-input"
								startAdornment={<InputAdornment position="start">$</InputAdornment>}
							/>
						</div>
					)}
					{(transactionType === "Trade In" || transactionType === "Collateral") && (
						<div style={{ margin: "20px 0px" }}>
							<Typography variant="h5" align="left">
								{newAsset.type}
							</Typography>
							<Divider style={{ marginBottom: 10 }} />
							<InputLabel htmlFor="amount-input" style={{ textAlign: "center" }}>
								Amount
							</InputLabel>
							<OutlinedInput
								style={{ width: "100%" }}
								value={amount}
								onChange={(e) => {
									setAmount(e.target.value);
									setNewAsset({
										...newAsset,
										price: parseInt(e.target.value),
									});
								}}
								type="number"
								id="amount-input"
								startAdornment={<InputAdornment position="start">$</InputAdornment>}
							/>
						</div>
					)}
					{transactionType === "Trade In" && (
						<div style={{ margin: "20px 0px" }}>
							<InputLabel htmlFor="payoff-input" style={{ textAlign: "center" }}>
								Payoff Amount
							</InputLabel>
							<OutlinedInput
								style={{ width: "100%" }}
								value={newAsset.payoff_amount}
								onChange={(e) =>
									setNewAsset({
										...newAsset,
										payoff_amount: parseInt(e.target.value),
									})
								}
								type="number"
								id="payoff-input"
								startAdornment={<InputAdornment position="start">$</InputAdornment>}
							/>
						</div>
					)}

					<div style={{ margin: "20px 0px" }}>
						<InputLabel htmlFor="vendor-input" style={{ textAlign: "center" }}>
							Vendor
						</InputLabel>
						<VendorSearch
							notSupported={false}
							vendor={vendor}
							newAddedvendor={vendor}
							setVendor={setVendor}
							isEdit
							type="asset"
						/>
					</div>
					<div style={{ margin: "20px 0px" }}>
						<InputLabel htmlFor="location-input" style={{ textAlign: "center" }}>
							Asset Location
						</InputLabel>
						<Select
							id="location-input"
							style={{ color: "#000000", width: "100%", textAlign: "left" }}
							value={newAsset.location_id}
							onChange={(e) =>
								setNewAsset({ ...newAsset, location_id: e.target.value })
							}>
							{locations.map((location) => (
								<MenuItem key={location.id} value={location.id}>
									{location.type +
										" : " +
										location.street +
										" " +
										location.city +
										" " +
										location.state +
										" " +
										location.zip}
								</MenuItem>
							))}
						</Select>
					</div>
				</div>
			) : (
				<div className={classes.content}>
					<div className={classes.assetCategory}>
						<div className={classes.header}>
							<h5>Transaction Type</h5>
						</div>
						<div className={classes.footer}>
							<Button
								size="small"
								className={
									selectedTranType === "Selling"
										? classes.selectedButtonStyle
										: classes.buttonStyle
								}
								variant="contained"
								onClick={() => {
									handleTrasactionType("Selling");
									setTransactionType("Selling");
									setSelectedTranType("Selling");
								}}>
								Selling
							</Button>
							<Button
								size="small"
								className={
									selectedTranType === "Trade In"
										? classes.selectedButtonStyle
										: classes.buttonStyle
								}
								color="primary"
								variant="contained"
								onClick={() => {
									handleTrasactionType("Trade In");
									setTransactionType("Trade In");
									setSelectedTranType("Trade In");
								}}>
								Trade In
							</Button>
							<Button
								size="small"
								className={
									selectedTranType === "Collateral"
										? classes.selectedButtonStyle
										: classes.buttonStyle
								}
								color="primary"
								variant="contained"
								onClick={() => {
									handleTrasactionType("Collateral");
									setTransactionType("Collateral");
									setSelectedTranType("Collateral");
								}}>
								Collateral
							</Button>
							<Button
								size="small"
								className={
									selectedTranType === "Cash Out"
										? classes.selectedButtonStyle
										: classes.buttonStyle
								}
								color="primary"
								variant="contained"
								onClick={() => {
									handleTrasactionType("Cash Out");
									setTransactionType("Cash Out");
									setSelectedTranType("Cash Out");
								}}>
								Cash Out
							</Button>
						</div>
					</div>

					{transactionType && (
						<div className={classes.assetType}>
							<div className={classes.header}>
								<h5>Asset Type</h5>
							</div>

							<Grid container className={classes.gridStyle}>
								<Button
									size="small"
									className={classes.buttonStyle}
									color="primary"
									variant="contained"
									onClick={() => {
										setNewAsset({ ...newAsset, type: "Truck - Chassis Only" });
									}}>
									Truck
								</Button>
								<Button
									size="small"
									className={classes.buttonStyle}
									color="primary"
									variant="contained"
									onClick={() => {
										setNewAsset({ ...newAsset, type: "Truck with Body" });
									}}>
									Truck with Body
								</Button>
							</Grid>
							<Grid container className={classes.gridStyle}>
								<Button
									size="small"
									className={classes.buttonStyle}
									color="primary"
									variant="contained"
									onClick={() => {
										setNewAsset({ ...newAsset, type: "Trailer" });
									}}>
									Trailer
								</Button>
								<Button
									size="small"
									className={classes.buttonStyle}
									color="primary"
									variant="contained"
									onClick={() => {
										setNewAsset({ ...newAsset, type: "Non-Titled" });
									}}>
									Non-Titled
								</Button>
							</Grid>
						</div>
					)}
				</div>
			)}
		</>
	);
};
export default NewAsset;
